import { HelpCircle } from 'lucide-react'
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/tooltip'

interface Props {
    hint: string
    className?: string
    contentClassName?: string
    side?: 'top' | 'right' | 'bottom' | 'left'
}

const HintIcon = ({
    hint,
    className = 'h-3.5 w-3.5',
    contentClassName = 'max-w-xs text-xs',
    side = 'right',
}: Props) => (
    <Tooltip>
        <TooltipTrigger asChild>
            <HelpCircle
                className={`text-muted-foreground cursor-help shrink-0 ${className}`}
            />
        </TooltipTrigger>
        <TooltipContent side={side} className={contentClassName}>
            {hint}
        </TooltipContent>
    </Tooltip>
)

export default HintIcon
